<template>
  <div class="acquisition" :class="{ 'acquisition-small': small }" :title="acquisition.title">
    <publication-cover ref="cover" :url="acquisition.cover" :small="small"></publication-cover>
  </div>
</template>

<script>
import PublicationCover from '@/components/publication/PublicationCover'

export default {
  name: 'acquisition',
  props: {
    acquisition: {
      type: Object,
      default: () => ({})
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    load () {
      if (this.$refs.cover?.loadImage) this.$refs.cover.loadImage()
    }
  },
  components: {
    'publication-cover': PublicationCover
  }
}
</script>

<style lang="scss" scoped>
  .acquisition {
    width: 100px;
    height: auto;
    margin: 0 10px;
    cursor: pointer;

    &-small {
      width: 60px;
      height: 90px;
    }

    &:hover {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
    }
  }
</style>
